import React, { Component } from 'react';
import AutoComplete from 'material-ui/AutoComplete';
import debounce from 'lodash/debounce';
import MenuItem from 'material-ui/MenuItem';
import Config from '../../Config';

let headers = new Headers();
headers.append('Content-Type', 'application/json');
headers.append('Authorization', `Bearer ${localStorage.getItem('authToken')}`);

class ParentAccountSearch extends Component {

  constructor(props) {
    super(props);
    this.state = { data: [], parentId: '' };
  }

  handleUpdateInput = (searchText, dataSource) => {
    console.log('handle update', this.state.parentId)
    const _this = this;
    if (searchText.length > 1) {
      fetch(`${Config.apiEndpoint}/collectives?search=${searchText}`, {
        method: 'GET',
        headers: headers,
      }).then(function (response) {
        if (response.ok) {
          response.json().then((json) => {
            const data = json.collectives.result.map(function (id) {
              const item = json.collectives.items[id];

              return { text: item.name, id: item.id, value: <MenuItem primaryText={item.name} /> };
            });

            _this.setState({ data: data });
          });
        }
      });
    };
  };

  handleSelect = (chosenRequest) => {
    if (typeof chosenRequest !== "object" && !chosenRequest.id) return;
    this.props.updateForm(chosenRequest.id);
  };

  render() {
    return (
      <AutoComplete
        key="parent-account"
        floatingLabelText={this.props.floatingLabelText || 'Parent Account'}
        floatingLabelFixed={true}
        hintText={this.props.hintText}
        dataSource={this.state.data}
        onUpdateInput={debounce(this.handleUpdateInput, 500)}
        onNewRequest={this.handleSelect}
        filter={AutoComplete.noFilter}
        openOnFocus={true}
        fullWidth={this.props.fullWidth}
        errorText={this.props.errorText}
        style={{margin: '0 10px'}}
      />
    );
  }
};

export default ParentAccountSearch;



/** WEBPACK FOOTER **
 ** ./components/forms/ParentAccountSearch.js
 **/